import { useRef, useState } from 'react';

export const IMAGE_UPLOAD_ACCEPT = 'image/png,image/jpeg,image/gif';

/** Runs the host-provided upload and hands the resulting URL to `onUploaded`. */
export function useImageUpload(onUploadImage: ((file: File) => Promise<string>) | undefined, onUploaded: (src: string) => void) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string>();
  // The upload is async: call the latest callback, not the one captured when it started,
  // so edits made meanwhile are not overwritten with stale blocks.
  const onUploadedRef = useRef(onUploaded);
  onUploadedRef.current = onUploaded;

  const upload = async (file: File | undefined) => {
    if (!file || !onUploadImage) return;
    setUploading(true);
    setError(undefined);
    try {
      onUploadedRef.current(await onUploadImage(file));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return { upload, uploading, error };
}
